<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SZjbs3/tc-custom/9781939931429.jpg?1696811664124" alt="This image is the cover for the book Year of the Comet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Year of the Comet
      </h1>
      <p class="bookDescription body article font2">
        <b>A coming of age novel set in a crumbling Soviet Union by the acclaimed author of </b><b><i>Oblivion</i></b><b>—“t</b><b>he best of Russia</b><b>’</b><b>s younger generation of writers</b><b>”</b><b>(</b><b><i>The New York Review of Books</i></b><b>).</b><br/>  <br/> As the Soviet Union edges toward collapse, a young boy’s idyllic childhood takes a sinister turn. Rumors of a serial killer haunt the neighborhood, families pack up and leave town without a word of warning, and the country begins to unravel. Policemen stand by as protesters overtake the streets, knowing that the once awe-inspiring symbols of power they wear on their helmets have become devoid of meaning.<br/>  <br/> In <i>The Year of the Comet</i>, the acclaimed Russian poet and novelist Sergei Lebedev depicts a vast empire coming apart at the seams, transforming a very public moment into something delicate and personal. With stunning beauty and shattering insight, Lebedev writes about the tenderness of childhood, the legacy of Stalinism, and the growing consciousness of a boy in the world.<br/>  <br/><b>“</b><b>A clear poetic sensibility built to stand against the forces of erasure.” —<i>The Wall Street Journal</i></b><br/>  <br/><b>“This gorgeously written, unsettling novel . . . leaves us with a fresh understanding of that towering moment in recent history” —<i>Kirkus Reviews</i> (starred review)</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sergei Lebedev
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Vessel Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?757a9c44